import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import get from 'lodash/get'

import SubLocationNotificationForm from '../../components/settings/sub-location-notification-form'
import {
  loadSubLocationNotificationPreferences,
  updateSubLocationNotificationPreferences
 } from '../../actions/settings'
import { fetchSubLocationsForUser } from '../../actions/sub-locations'

const fields = [
  'subLocationIds',
]

const mapStateToProps = (state, props) => {
  const subLocations = Object.values(state.subLocations)
  const subLocationIds = state.settings.subLocationPreferences || []
  const userType = get(state.auth, 'session.type')

  return {
    initialValues: {
      subLocationIds
    },
    subLocations: subLocations.map((sl) => ({ value: sl.id, label: `${sl.locationName}: ${sl.name}` })),
    userType
  }
}

const mapDispatchToProps = (dispatch, props) => {
  dispatch(fetchSubLocationsForUser())
  dispatch(loadSubLocationNotificationPreferences())

  return {
    onSubmit (data) {
      dispatch(updateSubLocationNotificationPreferences(data))
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'SubLocationNotificationPereferences'
  },
  mapStateToProps,
  mapDispatchToProps
)(SubLocationNotificationForm)



// WEBPACK FOOTER //
// ./src/containers/settings/sub-location-notification-form-container.js